export const productShortName = 'Pharmaceutical Manufacturing & GMP — Professional Edition';
export const productBrand = 'Pharmaceutical Manufacturing & GMP';
export const productEdition = 'Professional Edition';
export const productImage = 'https://cdn.magicpatterns.com/uploads/bqwDERid9CTnJetwgZKB3M/MOCKUP_PHARMA.png';
export const productImageAlt =
  'Pharmaceutical Manufacturing & GMP Professional Edition: six volumes covering manufacturing fundamentals, GMP and the quality system, cleanrooms, solid and liquid dosage, sterile manufacturing and validation and data integrity, plus five bonus resources';

export const checkoutUrl = 'https://pharmaceutical-manufacturing-gmp.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = 'USD 14.00';
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about how a medicine moves from the warehouse to batch release',
  'No more uncertainty about deviations, CAPA and change control',
  'No more gaps in understanding cleanrooms, pressure cascades and gowning',
  'No more guessing how granulation, compression, coating and aseptic filling work',
  'No more unclear ideas about validation, qualification and data integrity',
];
